import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { API_BASE } from "../../config/apiConfig";

import PageHeader from "../../components/pageHeader";
import MedalTallyCard from "../../components/performanceReview/medalTallyCard";
import SinglePlayerRankingProgression from "../../components/individualProfiles/singlePlayerRankingProgression";
import MedalByAgeGroupTable from "../../components/individualProfiles/medalByAgeGroupTable";
import TournamentSummaryTable from "../../components/individualProfiles/tournamentSummaryTable";
import TournamentParticipationTable from "../../components/individualProfiles/tournamentParticipationTable";
import MainContentLayout from "../../components/mainContentLayout";
import LoadingOverlay from "../../components/loadingOverlay";

export default function PerformanceReview() {
  const { playerId } = useParams();
  const user = useSelector((state) => state.user.user);

  const [results, setResults] = useState([]);
  const [ajssRankings, setAjssRankings] = useState([]);
  const [allTournaments, setAllTournaments] = useState([]);

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [loading, setLoading] = useState(false);
  const token = sessionStorage.getItem("access_token");

  // ------------------------------------------------------------
  // LOAD DATA FOR THIS PLAYER ONLY
  // ------------------------------------------------------------
  useEffect(() => {
    loadPlayerResults();
    loadPlayerAJSS();
    loadAllTournaments();
  }, [playerId]);

  async function loadPlayerResults() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/performance-results/${playerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      if (data.success) {
        setResults(data.results);

        // extract unique years
        const yrs = [...new Set(data.results.map((r) => r.year))].sort(
          (a, b) => b - a
        );
        setYears(yrs);
        if (!selectedYear && yrs.length > 0) setSelectedYear(yrs[0]);
      }
    } finally {
      setLoading(false);
    }
  }

  async function loadPlayerAJSS() {
    const res = await fetch(`${API_BASE}/api/performance-ajss/${playerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    if (data.success) {
      setAjssRankings(data.ajss);
    }
  }

  async function loadAllTournaments() {
    const res = await fetch(`${API_BASE}/api/performance-activities`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    if (data.success) {
      setAllTournaments(data.activities);
    }
  }

  const filteredResults = selectedYear
    ? results.filter((r) => r.year === selectedYear)
    : results;

  const backTo =
    user?.role?.includes("player")
      ? "/dashboard"
      : "/individual-profiles";

  return (
    <MainContentLayout>
      <LoadingOverlay show={loading} />

      <PageHeader title="Performance Review" backTo={backTo} />

      {/* Year Filter */}
      <div className="flex justify-end my-4">
        <select
          value={selectedYear || ""}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="border border-gray-400 rounded px-3 py-2"
        >
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {/* Player Snapshot */}
      <div className="grid grid-cols-1 gap-4 my-4">
        <MedalTallyCard results={filteredResults} />
        <MedalByAgeGroupTable results={filteredResults} />
        <TournamentSummaryTable results={filteredResults} />
      </div>

      {/* Ranking Progression */}
      <SinglePlayerRankingProgression ajssRankings={ajssRankings} />

      {/* Tournament Participation */}
      <TournamentParticipationTable
        results={filteredResults}
        tournaments={allTournaments}
      />
    </MainContentLayout>
  );
}
